/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from '../Config/Config';
import {Loader} from '../Helpers/Helpers';
import Parser from 'html-react-parser';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/glasses.json';

class Glass extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      error: null
    }
    this.selectGlass = this.selectGlass.bind(this);
  }

  selectGlass (e) {
    this.dispatchSelectGlass(e.currentTarget.value);
  }

  fetchGlasses = () => {
    var self = this;
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      self.dispatchGlassData(data);
      if ( self.props.selectedGlass === null ) {
        data.filter( ( glass ) =>
          'Yes' === glass['acf']['default_selected_glass']
        ).map( ( glass ) =>
          self.dispatchSelectGlass(glass.id)
        )
      }
      self.setState({ isLoaded: true });
    }, (ex) => {
      self.setState({ error: ex.message });
    })
  }

  dispatchGlassData(GlassData) {
    const data = GlassData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        glasses: data
      }
    })
  }

  dispatchSelectGlass(Glass) {
    const sData = Glass;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedGlass: sData
      }
    })
  }

  componentDidMount() {
    this.fetchGlasses();
  }

  render() {
    const { isLoaded, error } = this.state;
    if (error) {
      return <div className="alert alert-danger">{error}</div>;
    } else if (!isLoaded) {
      return <div className="loadingSec"><Loader/></div>;
    } else {
      return (
        <div className="row">
          <div className="col-sm-4">
            {this.props.glasses.map( (glass) =>
              <div className="print-items" key={glass.get('id')}>
                <div className="card h-100">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12">
                        <h4 className="card-title">
                          <label className="checkcontainer">
                            <input type="radio" name="glass" value={glass.get('id')} onChange={this.selectGlass} checked={parseFloat(this.props.selectedGlass) === glass.get('id') ? true : false } />{glass.getIn(['title', 'rendered'])}
                            <span className="radiobtn"></span>
                          </label>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <GlassContent
            {...this.props}
            selectedGlass={this.props.selectedGlass}
            glasses={this.props.glasses} />
        </div>
      );
    }
  }
}
export default Glass;

class GlassContent extends Component {
  render() {
    const { glasses, selectedGlass } = this.props;
    if ( selectedGlass === null ) {
      return (
        <div className="col-sm-8 print-items"></div>
      );
    }
    return (
      <div className="col-sm-8 print-items">
        {glasses.filter( ( glass ) =>
          parseFloat(selectedGlass) === glass.get('id')
        ).map( ( glass ) =>
          <div key={glass.get('id')}>
            <div className="price-tab">
              {Constants.Currency + this.props.glassTotal}
            </div>
            {Parser(glass.getIn(['content', 'rendered']))}
          </div>
        )}
      </div>
    );
  }
}